import React from 'react';
import { Icon } from '@express-labs/raven-ui';
import { cn } from '@express-labs/raven-tools';
import PropTypes from 'prop-types';
import s from './LoggedInIcon.module.scss';

function LoggedInIcon({
  userData, className, toggleRewardsToolTip, ...restOfProps
}) {
  const { firstName, lastName, rewardsTotal } = userData;

  const LoggedInUserName = (first, last) => `${first.charAt(0)}${last.charAt(0)}`;
  const check = firstName && lastName;
  const styles = Object.entries(userData).length > 0 ? cn(s.loginLogo, className) : s.loginBtn;

  return (
    <div className={cn(s.loggedInIconContainer, !rewardsTotal ? s.loggedInIconContainerCenter : '')}>
      <button type="button" className={styles} {...restOfProps} aria-label="logged in icon">
        {check ? (
          <>
            <span className={cn(s.loginInitial, 'rvnEyebrow')} data-qm-encrypt>
              {LoggedInUserName(firstName, lastName)}
            </span>
            <Icon icon="myAccountLoginLogo" />
          </>
        ) : (
          <Icon icon="account" />
        )}
      </button>
      {check && rewardsTotal > 0 && (
        <span
          className={cn(s.rewardsNotifier, 'rvnEyebrow')}
          onClick={toggleRewardsToolTip}
          role="presentation"
        >
          {`$${rewardsTotal}`}
        </span>
      )}
    </div>
  );
}

LoggedInIcon.propTypes = {
  className: PropTypes.string,
  userData: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    rewardsTotal: PropTypes.number,
  }),
  toggleRewardsToolTip: PropTypes.func,
};

LoggedInIcon.defaultProps = {
  className: null,
  userData: {
    firstName: '',
    lastName: '',
    rewardsTotal: 0,
  },
  toggleRewardsToolTip: null,
};

export default LoggedInIcon;
